import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import Ticker from "./Ticker";

export default function Layout() {
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });

    return () => unsub();
  }, []);

  const isLoggedIn = !!user;

  const hiddenRoutesWhenLoggedIn = ["/home", "/update", "/engage", "/yard"];

  const hideTicker =
    isLoggedIn && hiddenRoutesWhenLoggedIn.includes(location.pathname);

  return (
    <div>
      <Outlet />
      {!hideTicker && <Ticker />}
    </div>
  );
}